<template>
    <div class="black-ice-page-news-widget">
        <main class="black-ice-news-wrapper">
            <strong class="pl-3">Latest Updates</strong>
            <div class="back-ice-news-posts">
                <a class="news-post-wrapper" v-for="news_post in news_posts" @click="loadNewsPost(news_post.NewsID)">
                    <div class="news-post">
                        <div class="news-post-content">
                            <div class="title">
                                <h1>{{ news_post.NewsTitle }}</h1>
                            </div>
                            <div class="date">
                                {{ news_post.EnteredDate }}
                            </div>
                        </div>
                    </div>
                </a>
            </div>
            <template v-if="total_count > 20">
                <div class="pagination-bar ml-3 mr-3">
                    <div class="row">
                        <div class="col">
                            <a @click.prevent="prevPage()" v-if="current_page > 1" class="btn-default _sm"><i
                                class="fa fa-caret-left"></i></a>
                            <a class="btn-default _sm">{{ current_page }} / {{ total_pages }}</a>
                            <a @click.prevent="nextPage()" v-if="current_page < total_pages"
                               class="btn-default _sm"><i class="fa fa-caret-right"></i></a>
                        </div>
                        <div class="col align-right">
                            <div class="mt-1 mb-1">
                                {{ total_count }} results found
                            </div>
                        </div>
                    </div>
                </div>
            </template>
        </main>
        <div class="modal-window" :class="{'open': open_news_post !== null}" @click="open_news_post = null" v-if="open_news_post !== null">
            <div class="modal-window-inner" @click.stop>
                <div class="modal-close" @click.stop="open_news_post = null">
                    <i class="fal fa-times"></i>
                </div>
                <div class="modal-header">
                    <h1 class="modal-title">
                        {{ open_news_post.NewsTitle }}
                    </h1>
                </div>
                <div class="modal-content">
                    <p>
                        Published: {{ open_news_post.EnteredDate }}
                    </p>
                    <p v-html="open_news_post.NewsContent">
                    </p>
                </div>
                <div class="modal-footer align-right">
                    <a class="btn-primary" @click="sendEnquiry()">
                        Send
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    data() {
        return {
            news_posts: [],
            current_page: 1,
            total_count: 0,
            total_pages: 0,
            portal: 'profile22',
            open_news_post: null,
        };
    },
    mounted() {
        this.loadNewsPosts();
    },
    methods: {
        loadNewsPosts() {
            axios.post('/commercial/black-ice-api/getNews', {
                page_number: this.current_page,
                portal: this.portal,
            }).then((response) => {
                this.news_posts = response.data.data;
                this.total_count = response.data.total;
                this.total_pages = response.data.last_page;
            });
        },
        loadNewsPost(id) {
          axios.post('/commercial/black-ice-api/getNewsPost', {
            post_id: id,
          }).then((response) => {
            this.open_news_post = response.data;
          });
        },
        prevPage() {
            this.current_page = this.current_page - 1;
            this.loadNewsPosts();
        },
        nextPage() {
            this.current_page = this.current_page + 1;
            this.loadNewsPosts();
        }
    },
    watch: {
        portal() {
            this.current_page = 1;
            this.loadNewsPosts();
        },
    },
};
</script>
